import { Component, OnInit, Input, OnChanges, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-overview-widget',
  templateUrl: './overview-widget.component.html',
  styleUrls: ['./overview-widget.component.scss']
})
export class OverviewWidgetComponent implements OnInit {

  @Input() busy;
  @Input() type;
  @Input() metric;
  @Input() total;
  @Input() metricName;
  @Input() color;
  @Input() videoTooltip;
  @Output() video = new EventEmitter();
  @Input() actionText;
  @Output() action = new EventEmitter();

  public circumference = "";

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(){
    this.circumference = Math.round(this.metric/this.total*100) + " " + (100 - Math.round(this.metric/this.total*100));
  }

  tutorialClick(){
    this.video.emit({type: this.type});
  }

  actionClick(){
    this.action.emit({type: this.type});
  }

}
